import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { UtilityRateService } from 'brain-data/service/utility-rate/utility-rate.service';
import {
  createUtilityRate,
  createUtilityRateError,
  createUtilityRateSuccess,
  deleteUtilityRate,
  deleteUtilityRateError,
  deleteUtilityRateSuccess,
  loadUtilityRates,
  loadUtilityRatesError,
  loadUtilityRatesSuccess,
  updateUtilityRate,
  updateUtilityRateError,
  updateUtilityRateSuccess,
} from '../actions/utility-rate.action';

@Injectable()
export class UtilityRateEffects {
  loadUtilityRates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUtilityRates),
      switchMap(() =>
        this.service.getAll().pipe(
          map(rates => loadUtilityRatesSuccess({ rates })),
          catchError((error: HttpErrorResponse) => of(loadUtilityRatesError({ error }))),
        ),
      ),
    ),
  );

  createUtilityRate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createUtilityRate),
      switchMap(({ payload }) =>
        this.service.create(payload).pipe(
          map(rate => createUtilityRateSuccess({ rate })),
          catchError((error: HttpErrorResponse) => of(createUtilityRateError({ error }))),
        ),
      ),
    ),
  );

  updateUtilityRate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateUtilityRate),
      switchMap(({ id, payload }) =>
        this.service.update(id, payload).pipe(
          map(rate => updateUtilityRateSuccess({ rate })),
          catchError((error: HttpErrorResponse) => of(updateUtilityRateError({ error }))),
        ),
      ),
    ),
  );

  deleteUtilityRate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteUtilityRate),
      switchMap(({ id }) =>
        this.service.delete(id).pipe(
          map(() => deleteUtilityRateSuccess({ id })),
          catchError((error: HttpErrorResponse) => of(deleteUtilityRateError({ error }))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: UtilityRateService,
  ) {}
}
